import React, { useState, Component } from 'react';
import Heading from '../Atoms/Heading.js';
import Button from '../Atoms/Button'
import { Link } from 'react-router-dom'


function goBack() {
  window.history.back();
}

function noBack() {
  console.log('🤷‍♂️')
}

function TopBar(props) {
  


    return <div className="bb flex max-w-100 h-3 phone-h-6 ">
        <Link to="/" className="br flex-basis-75 items-center align-content-center flex pl-m h3 " >
          <Heading cx="" content={props.open?  "Sonja Lillebæk Christensen" : "◀ HJEM"} headingLevel="h1"/>
        </Link>

        {props.open ? 
        //  <div >
        //   <Button cx="full-height justify-content-center items-center flex"  width="100"  link="../menu" content="MENU"/>
        // </div>
        <button className=" h-3 flex flex-basis-4th items-center no-shrink ta-center justify-content-center p-0 margin-b-0 margin-t-0" style={{fontSize: '12px'}} onClick={goBack}>LUK ❌</button>
        :
        <div className=" h-3 flex flex-basis-4th items-center no-shrink">
          <Button cx="full-height justify-content-center items-center flex"  width="100"  link="../menu" content="MENU"/>
        </div>
      }
       




      </div>
    
  
}

export default TopBar;